import React from "react";
import { useNavigate } from "react-router-dom";

import PageError from "src/components/Errors/PageError.tsx";
import { useT } from "src/internationalization";

const Page404: React.FC = () => {
  const navigate = useNavigate();
  const t = useT();

  return (
    <PageError
      title={t("page.notfound.title")}
      description={t("page.notfound.description")}
      textButton={t("page.notfound.button")}
      onClick={() => navigate(-1)}
    />
  );
};

export default Page404;
